/*
 * File: SalesOrderNumberSearch.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 16 Nov 2021 1:23:25 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Space } from 'antd';
import { FancyInput } from 'components/atoms/FancyInput';
import React, { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { setFilterSalesOrderNumber } from 'redux/salesOrder/ordersSlice';
import { useDebouncedCallback } from 'use-debounce';

export const SalesOrderNumberSearch = (): JSX.Element => {
  const dispatch = useDispatch();

  /* ****************** Functions ****************** */
  // Handle delay of searching data
  const handleInputChange = useDebouncedCallback((ev: ChangeEvent<HTMLInputElement>) => {
    dispatch(setFilterSalesOrderNumber(ev.target.value));
  }, 500);

  /* ****************** Render ****************** */
  return (
    <Space direction="vertical" size="small">
      <FancyInput onChange={handleInputChange} placeholder="SO Number" width={150} />
    </Space>
  );
};
